import React from 'react';

const ParticlesAuth = ({ children }: { children: React.ReactNode }) => {
    return (
        <div className="relative flex min-h-screen flex-col bg-muted">
            <div className="flex flex-1 flex-col items-center justify-center">
                {children}
            </div>

            <footer className="py-4 text-center">
                <p className="mb-0 text-sm text-muted-foreground">
                    &copy; {new Date().getFullYear()} Ad Pulse. Feito com{' '}
                    <span className="text-red-500">&#10084;</span>
                </p>
            </footer>
        </div>
    );
};

export default ParticlesAuth;
